import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { KoreanContainer, KoreanItem } from '../../styles/onBoardStyle';
import Checkbox from './checkbox';

interface MicrositeApacPPProps {
	isFirstChecked: boolean;
	checkFirst: (checked: boolean) => void;
	requiresConsent: boolean;
	checkboxColor?: string;
}

const MicrositeApacPP = ({ isFirstChecked, checkFirst, requiresConsent, checkboxColor }: MicrositeApacPPProps) => {
	const { t } = useTranslation();

	return (
		<Container>
			<KoreanItem style={{ marginLeft: 'initial' }}>
				<label dangerouslySetInnerHTML={{ __html: t('microsite-privacy-notice') }} />
			</KoreanItem>

			{requiresConsent && (
				<KoreanItem>
					<Checkbox checked={isFirstChecked} onChange={(event) => checkFirst(event.target.checked)} color={checkboxColor} />
					<label dangerouslySetInnerHTML={{ __html: t('microsite-privacy-consent') }} />
				</KoreanItem>
			)}
		</Container>
	);
};

const Container = styled(KoreanContainer)`
	padding: 0 0 24px;

	a {
		color: inherit;
		text-decoration: underline;
	}
`;

export default MicrositeApacPP;
